import { AppContext } from '../AppContext';
const instanceMap = new Map();
export class Service extends Object {
    static serviceName = '';
    static locate(name) {
        return instanceMap.get(name);
    }
    constructor() {
        super();
        if (instanceMap.get(this.constructor.name))
            throw new Error('Singleton not allowed to construct more than one');
        instanceMap.set(this.constructor.serviceName || this.constructor.name, this);
        AppContext.provide(`service:${this.constructor.name}`, this);
    }
}
//# sourceMappingURL=Service.js.map